import "./FAQKnowledgeCenter.module.css";
import Header from "@/reusable_sections/Header";
import Introduction from "./sections/Introduction";
import LifeInsurance from "./sections/LifeInsurance";
import Annuities from "./sections/Annuities";
import Mygas from "./sections/Mygas";
import RetirementIncome from "./sections/RetirementIncome";
import FinalExpense from "./sections/FinalExpense";
import IncomeProtection from "./sections/IncomeProtection";
import Legacy from "./sections/Legacy";
import Comparisons from "./sections/Comparisons";
import Consulting from "./sections/Consulting";
import GlossaryCallout from "./sections/GlossaryCallout";
import Footer from "@/reusable_sections/Footer";
export default function FAQKnowledgeCenterPage() {
  return <div>
      <Header />
      <Introduction />
      <LifeInsurance />
      <Annuities />
      <Mygas />
      <RetirementIncome />
      <FinalExpense />
      <IncomeProtection />
      <Legacy />
      <Comparisons />
      <Consulting />
      <GlossaryCallout />
      <Footer />
    </div>;
}